import React, { forwardRef } from 'react';

import MUITableContainer, {
  TableContainerProps as MUITableContainerProps,
} from '@material-ui/core/TableContainer';

export interface TableContainerProps extends MUITableContainerProps {}

const TableContainer = forwardRef<HTMLDivElement, TableContainerProps>(
  (props, ref) => {
    return <MUITableContainer {...props} ref={ref} />;
  }
);

export default TableContainer;
